export const emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,10}$';

export const fullName = '^[^,&]+$';

export const namePattern = '^[^,&]+$';

export const passwordPattern =
	'^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~]).*$';
